<data-table-content-editor
  #contentEditor
  [componentId]="componentId"
  [loadContent]="loadContentData"
  [saveContent]="saveContentData"
></data-table-content-editor>
